import { DYNAMIC_QUESTION_TYPE } from 'app-constants';

export const otherSignatoryField = (createdById, signatories, fieldRole) => {
  const signatoryItem = signatories.signatoryParticipants?.find(({ Id }) => Id === createdById);

  const fieldRoleId = fieldRole.formRole || fieldRole.roleId;

  const isOtherSignatoryField = !signatoryItem || signatoryItem.RoleId !== fieldRoleId;

  let isSequentialDisabled =
    !isOtherSignatoryField &&
    signatories.isSequentialSigning &&
    signatoryItem.SignatureSequence !== 1;

  return { isOtherSignatoryField, isSequentialDisabled };
};

export const isPlaceholderField = (field) => {
  const { type } = field;
  const { TextBox, Address, Number, Phone, Currency, FullName } = DYNAMIC_QUESTION_TYPE;

  return (
    type === TextBox ||
    type === Address ||
    type === Number ||
    type === Phone ||
    type === Currency ||
    type === FullName
  );
};
